module.exports = __webpack_public_path__ + "files/4e980a88adaeddb9d88187f7cda2d456.png";